const enum Granularity {
  OneMinute = "OneMinute",
  FiveMinutes = "FiveMinutes",
  Hour = "Hour",
  Day = "Day",
  Week = "Week",
  Month = "Month",
  Year = "Year",
  IsoYear = "IsoYear",
}

export default Granularity;
